<template>
  <v-app :id="time">
    <div style="text-align: center; padding-left: 30% !important" width="100%">
      <v-alert
        v-if="responseStatus.alertStatus"
        :type="responseStatus.type"
        width="40%"
        style="z-index: 9999; text-align: left"
        dense
        dismissible
      >
        {{ responseStatus.text }}
      </v-alert>
    </div>
    <div>
      <v-card app>
        <v-card-title>{{ name }}</v-card-title>
        <v-card-text>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field
                    label="คะแนนหมดอายุ (เดือน) *"
                    hide-details="auto"
                    type="number"
                    v-model="pointExpire"
                  ></v-text-field>
                  <div class="v-messages theme--dark">
                    <div class="v-messages__wrapper"></div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn class="success" @click="save" :disabled="!isValid">
            <v-icon>mdi-content-save-outline</v-icon> บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-app>
</template>

<script>
//import _ from "underscore";
//import moment from "moment";
import axios from "axios";

export default {
  name: "pointExpire",
  data: () => ({
    // datepicker
    name: " point Expire",
    time: new Date().toTimeString(),
    valid: false,

    //value: "",
    //point: "",
    //points: [],
    point_type: "ExpirePoint",
    status: "",

    pointExpire: "",
    lists: [],
    isEdit: false,
    deleteIndex: -1,
    deleteItem: {},
    responseStatus: {
      alertStatus: false,
      text: "",
    },
    api_uri: process.env.VUE_APP_LOYALTY_API_URI,
    closeInSec: process.env.VUE_APP_ALERT_DISPLAY * 1000,
    custId: sessionStorage.getItem("custId"),
    dialogDelete: false,
  }),
  created() {
    console.log("-point");
  },
  mounted() {
    console.log("-point");
    this.init();
  },
  computed: {
    isValid() {
      //console.log('isValid');
      //console.log(this.pointExpire);
      if (
        this.pointExpire == "" ||
        this.pointExpire <= 0
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    async init() {
      console.log("call pointExpire");
      let response = await axios.get(this.api_uri + "/v1/point/expire", {
        params: {
          //updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),
          //apiKey: sessionStorage.getItem("apiKey"),
        },
      });
      console.log("pointExpire called");
      console.log(response);
      if (response.data.data._id === undefined || response.data.data === undefined) {
        this.pointExpire = "";//response.data.data.cfg_value.expire_value
      } else {
        this.pointExpire = response.data.data.cfg_value.expire_value
      }
      console.log(this.pointExpire);
      //return pointExpire;
    },

    async save() {
      console.log(this.pointExpire);
      //// console.log(process.env.VUE_APP_OGF_CUST_ID);
      const payload = {
        cfg_value: {expire_value: this.pointExpire,expire_time:"month"},
        cfg_name: "ExpirePoint",
        cfg_code: "ExpirePoint",
        //custId: this.custId,
        createdBy: sessionStorage.getItem("email"),
        updatedBy: sessionStorage.getItem("email"),
        custId: sessionStorage.getItem("custId"),
        cfg_description:"แต้มหมดอายุ"
      };
      if (payload._id == "") {
        delete payload._id;
      }
         
      let   uri = "/v1/point/expire";
      

      try {
        //
        await axios
          .post(
            this.api_uri + uri,
            payload, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            //// console.log('Added')
            console.log(response.data)
            //this.Reward = response.data;
            if (response.data._id) {
              // this.points.push(response.data);
              this.pointExpire = response.data.cfg_value.expire_value;
            }
            this.responseStatus = {
              status: "Success",
              code: 0,
              color: "green",
              type: "success",
              text: "บันทึกสำเร็จ",
              alertStatus: true,
              data: response.data,
            };

            //// console.log(this.responseStatus)
            //this.Reward = response.data;
            //this.resetInput();
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        };
      }
      //// console.log("$emit (Update)");
      //this.$emit("updatePointStatus", this.responseStatus);
      // this.resetInput();
    },
    resetInput() {
      //this.pointExpire = ;
    },

    // timeout close overlay
    /*
                        closeInTime(sec) {
                        setTimeout(() => {
                            this.responseStatus.alertStatus = false;
                        }, sec);
                        },
                        */
  },
  watch: {
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
